import MobileUserMenu from '@/components/MobileUserMenu.tsx'
import UserMenuComp from '@/components/UserMenuComp.tsx'
import { getAssetsPageRoute, getUserCenterPageRoute, PageRoutes, UserCenterRoutes } from '@/constants/PageRoutes'
import useUserCommon from '@/hooks/use-user-common.ts'
import { APP_CONFIG } from '@/project-config'
import { ArrowDownBold } from '@element-plus/icons-vue'
import classNames from 'classnames'
import { useContents } from 'cloud-computing-power/config'
import { PageRoutes as CloudComputingPowerRoutes } from 'cloud-computing-power/constants/PageRoutes'
import { PageRoutes as DebitCardRoutes } from 'debit-card/constants/PageRoutes'
import { ElIcon, ElSpace } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { ProjectTheme } from 'platform-config'
import { useIpRestrictStore, useProjectTheme, useResponsive, useUserInfoStore } from 'store'
import {
  CalculatorIcon,
  CloudComputingPowerIcon,
  ComputingPowerIncomeIcon,
  ComputingPowerOrdersIcon,
  CustomButton,
  DarkThemeIcon,
  DialogHeader,
  HeaderAssetIcon,
  HocElDialog,
  HocElDivider,
  HocElPopover,
  LightThemeIcon,
  MenuIcon,
  SvgIcon,
  Uid,
  useDialog,
  UserIcon,
  UserVipIcon,
} from 'ui-components'
import { firstCharToUpper } from 'utils'
import type { VNode } from 'vue'
import { RouterLink } from 'vue-router'
import { ChangeLanguageCurrency } from './ChangeLanguageCurrency'
import { CopyText } from './Copy'
import { HeaderAppDownload } from './HeaderAppDownload'
import { HeaderCompLayout } from './HeaderComp.layout.tsx'
import './HeaderComp.scss'
import { HomeMobileMenu } from './HomeMobileMenu'

type TabItem = {
  title?: string
  path: string
  icon?: VNode
  subTitle?: string
  children?: TabItem[]
}

const DebitCard = import.meta.env.VITE_DEBIT_CARD_MODULE
console.log('DebitCard', DebitCard)
export const HeaderComp = defineComponent({
  setup() {
    const isUserPopover = ref(false)

    const { t } = useI18n()
    const route = useRoute()
    const router = useRouter()
    const userInfoStore = useUserInfoStore()
    const themeStore = useProjectTheme()
    const theme = computed(() => themeStore.theme)
    const { buttonRadius } = useContents()
    const responsive = useResponsive()
    const { dialogVisible, openDialog, closeDialog } = useDialog()
    const { dialogVisible: open, openDialog: openUserDialog, closeDialog: closeUserDialog } = useDialog()
    const { avatar, username, onLogout, vipLevel } = useUserCommon()
    const isShowCloud = ref(false)
    const ipRestrictStore = useIpRestrictStore()
    let autoCloseUserPopover: NodeJS.Timeout | null = null
    const getDebitCardList = () => {
      if (DebitCard) {
        return [
          {
            title: '信用卡',
            path: DebitCardRoutes.DebitIndex,
            children: [
              // { title: '落地页', path: DebitCardRoutes.Home, icon: <CloudComputingPowerIcon /> },
              { title: '卡列表', path: DebitCardRoutes.DebitIndex, icon: <SvgIcon dir="menu" name="1" size={20} /> },
              { title: '卡片', path: DebitCardRoutes.MyCards, icon: <SvgIcon dir="menu" name="2" size={20} /> },
              { title: '卡包', path: DebitCardRoutes.CardPackage, icon: <SvgIcon dir="menu" name="3" size={20} /> },
            ],
          },
        ]
      }
      return []
    }
    const getCloudComputingPowerList = () => {
      if (!APP_CONFIG.isOpenCloudComputingPower) return []
      return [
        {
          title: '云算力',
          path: CloudComputingPowerRoutes.Cloud,
          children: [
            { title: '购买算力', path: CloudComputingPowerRoutes.Cloud, icon: <CloudComputingPowerIcon /> },

            { title: '计算器', path: CloudComputingPowerRoutes.Calculator, icon: <CalculatorIcon /> },
            ...(userInfoStore.isLogin
              ? [
                  { title: '算力订单', path: CloudComputingPowerRoutes.Order, icon: <ComputingPowerOrdersIcon /> },
                  { title: '算力收益', path: CloudComputingPowerRoutes.Income, icon: <ComputingPowerIncomeIcon /> },
                ]
              : []),
          ],
        },
      ]
    }

    const tabs = computed<TabItem[]>(() => {
      // IP 受限时只显示法律与合规
      if (ipRestrictStore.isIpRestricted) {
        if (APP_CONFIG.isCompliant) {
          return [
            {
              title: '法律与合规',
              path: PageRoutes.LegalCompliance,
            },
          ]
        }
        return []
      }

      const list = [
        {
          title: '行情',
          path: PageRoutes.Quote,
        },
        {
          title: '现货',
          path: PageRoutes.SpotTrade,
        },
        {
          title: 'U本位合约',
          path: PageRoutes.ContractTrade,
        },
        ...getCloudComputingPowerList(),
        ...getDebitCardList(),
        {
          title: '投资理财',
          path: PageRoutes.Invest,
        },
      ]
      // if (APP_CONFIG.isCompliant && APP_CONFIG.compliantPosition === 'header') {
      //   list.push({
      //     title: '法律与合规',
      //     path: PageRoutes.LegalCompliance,
      //   })
      // }
      return list
    })

    const rightTabs = computed<TabItem[]>(() => {
      // IP 受限时不显示资产入口
      if (ipRestrictStore.isIpRestricted) {
        return []
      }
      const list = []
      if (userInfoStore.isLogin) {
        list.push({
          icon: <HeaderAssetIcon />,
          path: getAssetsPageRoute(UserCenterRoutes.SpotOrder),
        })
      }
      return list
    })

    const onLogin = () => {
      router.push(PageRoutes.Login)
    }

    // 充值
    const onRecharge = () => {
      router.push(getUserCenterPageRoute(UserCenterRoutes.Recharge))
    }

    // const onWithdraw = () => {
    //   router.push(getUserCenterPageRoute(UserCenterRoutes.Withdraw))
    // }

    const onRegister = () => {
      router.push({
        path: PageRoutes.Register,
        query: {
          entry: 'home_header',
        },
      })
    }

    const openMenu = () => {
      openDialog()
    }

    watch(
      () => route.path,
      () => {
        closeDialog()
      },
    )

    const onAutoCloseUserPopover = () => {
      autoCloseUserPopover = setTimeout(() => {
        isUserPopover.value = false
      }, 3000)
    }

    const clearAutoCloseUserPopover = () => {
      if (autoCloseUserPopover) {
        clearTimeout(autoCloseUserPopover)
        autoCloseUserPopover = null
      }
    }

    onMounted(() => {
      document.body.addEventListener('click', () => {
        isUserPopover.value = false
        clearAutoCloseUserPopover()
      })
    })

    const shoeMobileLogin = computed(() => {
      const isShow = ![
        PageRoutes.Login,
        PageRoutes.Register,
        PageRoutes.LoginInputPassword,
        PageRoutes.PreForgetPassword,
        PageRoutes.ResetPassword,
        PageRoutes.RegisterPassword,
        PageRoutes.RegisterAuthEmail,
        PageRoutes.RegisterAuthMobile,
      ].includes(route.path as PageRoutes)

      return isShow && responsive.isMobile
    })

    return () => (
      <div class="crypto-header-comp-layout">
        <HeaderCompLayout class="header-comp-layout">
          <div class="header-nav-container">
            <RouterLink class="logo-box" to="/">
              <img width={theme.value.logoWidth || 130} src={theme.value.logo} alt="logo" />
            </RouterLink>
            <nav class="top-nav left">
              {tabs.value.map((tab) => {
                if (tab.children?.length) {
                  return (
                    <HocElPopover
                      teleported={false}
                      placement="bottom-start"
                      trigger="hover"
                      showAfter={0}
                      hideAfter={0}
                      onShow={() => (isShowCloud.value = true)}
                      onHide={() => (isShowCloud.value = false)}
                    >
                      {{
                        reference: () => (
                          <div class={classNames('nav-item', { active: tab.path === route.path })}>
                            {tab.title && <span>{t(tab.title)}</span>}
                            {tab.icon}
                            <ElIcon class={classNames('arrow', { 'is-show': isShowCloud.value })}>
                              <ArrowDownBold />
                            </ElIcon>
                          </div>
                        ),
                        default: () => (
                          <div class="sub-menu">
                            <p class="sub-title">{t(tab.title || '')}</p>
                            {tab?.children?.map((child) => (
                              <RouterLink to={child.path} key={child.path} class={classNames('sub-menu-item', { active: child.path === route.path })}>
                                <div class="sub-menu-wrap">
                                  {child.icon}
                                  <span class="desc-wrap">{t(child.title || '')}</span>
                                </div>
                              </RouterLink>
                            ))}
                          </div>
                        ),
                      }}
                    </HocElPopover>
                  )
                }
                if (tab.path === route.path) {
                  return (
                    <a href="javascript:void(0)" class={'active'}>
                      {tab.title && t(tab.title)}
                    </a>
                  )
                }

                return (
                  <RouterLink to={tab.path} key={tab.path} class={classNames({ active: tab.path === route.path })}>
                    {tab.title && t(tab.title)}
                  </RouterLink>
                )
              })}
            </nav>
            <nav class={'top-nav right'}>
              {/* IP 受限时隐藏用户菜单 */}
              {!ipRestrictStore.isIpRestricted && userInfoStore.isLogin && (
                <HocElPopover visible={isUserPopover.value} width={'auto'} teleported={false} appendTo={document.body} placement={'bottom-end'} showArrow={false} offset={0}>
                  {{
                    reference: () => (
                      <div
                        class="user-icon"
                        onClick={(e) => {
                          e.stopPropagation()
                          isUserPopover.value = !isUserPopover.value
                          clearAutoCloseUserPopover()
                          onAutoCloseUserPopover()
                        }}
                      >
                        <UserIcon />
                      </div>
                    ),
                    default: () => (
                      <div class="user-menu-container" onClick={(e) => e.stopPropagation()} onMousemove={clearAutoCloseUserPopover} onMouseout={onAutoCloseUserPopover}>
                        <div class="user-info">
                          <div class="avatar">
                            <img src={avatar.value} alt="avatar" />
                          </div>
                          <div class="user-name">
                            <p class="user-name-text">{username.value}</p>
                            <p class="user-id">
                              <span>UID:</span>
                              <Uid />
                              <CopyText value={userInfoStore.userInfo?.userInfo?.btUserId || userInfoStore.userInfo?.userInfo?.userId} />
                            </p>
                            {vipLevel.value?.isGreaterThan(0) && (
                              <div class="vip-info">
                                <UserVipIcon /> VIP{vipLevel.value}
                              </div>
                            )}
                          </div>
                        </div>
                        <div class="menu-list">
                          <UserMenuComp
                            onClose={() => {
                              isUserPopover.value = false
                            }}
                          />
                        </div>
                        <HocElDivider direction="horizontal"></HocElDivider>
                        {/* 退出登录 */}
                        <div class="bottom-logout-item">
                          <div class="logout-btn" onClick={onLogout}>
                            {t('退出登录')}
                          </div>
                        </div>
                      </div>
                    ),
                  }}
                </HocElPopover>
              )}
              {/* IP 受限时隐藏登录注册按钮 */}
              {!ipRestrictStore.isIpRestricted && !userInfoStore.isLogin && (
                <>
                  <div onClick={onLogin} class={'login-register-btn'}>
                    {t('登录')}
                  </div>
                  <CustomButton type="primary" class={'register'} radius={buttonRadius.value} onClick={onRegister}>
                    {t('注册')}
                  </CustomButton>
                </>
              )}
              {rightTabs.value.map((tab) => (
                <RouterLink to={tab.path} class={classNames({ active: tab.path === route.path })}>
                  {tab.title && firstCharToUpper(t(tab.title))}
                  {tab.icon}
                </RouterLink>
              ))}

              <HeaderAppDownload />
              <ChangeLanguageCurrency />
              {APP_CONFIG.isShowThemeSwitch && (
                <div class="theme-icon" onClick={() => themeStore.toggleTheme()}>
                  {themeStore.themeType === ProjectTheme.Light ? <LightThemeIcon /> : <DarkThemeIcon />}
                </div>
              )}
            </nav>
            <ElSpace size={12}>
              {/* IP 受限时隐藏移动端登录按钮 */}
              {!ipRestrictStore.isIpRestricted && !userInfoStore.isLogin && shoeMobileLogin.value && (
                <>
                  <CustomButton radius={6} class="recharge-btn" type="primary" style={{ height: '30px' }} onClick={onLogin}>
                    {t('登录')}
                  </CustomButton>
                </>
              )}
              {/* IP 受限时隐藏移动端用户相关按钮 */}
              {!ipRestrictStore.isIpRestricted && userInfoStore.isLogin && responsive.isMobile && (
                <>
                  <CustomButton radius={6} class="recharge-btn" style={{ height: '30px' }} type="primary" onClick={onRecharge}>
                    {t('充值')}
                  </CustomButton>
                  {/* <CustomButton radius={6} class="recharge-btn" style={{ height: '30px' }} type="primary" onClick={onWithdraw}>
                    {t('提现')}
                  </CustomButton> */}
                  <span onClick={openUserDialog}>
                    <UserIcon />
                  </span>
                </>
              )}

              <span class="menu-icon" onClick={openMenu}>
                <MenuIcon />
              </span>
            </ElSpace>
          </div>
        </HeaderCompLayout>

        <HocElDialog v-model={open.value} placement="right" closeOnClickModal={false} modal={false} offsetTop={0} showClose={false} onClose={closeUserDialog} appendToBody>
          {{
            header: () => (
              <DialogHeader onClose={closeUserDialog} height={64}>
                <img width={theme.value.logoWidth || 130} src={theme.value.logo} alt="logo" onClick={() => router.push(PageRoutes.Home)} />
              </DialogHeader>
            ),
            default: () => <MobileUserMenu onClose={closeUserDialog} />,
          }}
        </HocElDialog>

        <HocElDialog v-model={dialogVisible.value} placement="right" closeOnClickModal={false} modal={false} offsetTop={0} showClose={false} onClose={closeDialog} appendToBody>
          {{
            header: () => (
              <DialogHeader onClose={closeDialog} height={64}>
                <img width={theme.value.logoWidth || 130} src={theme.value.logo} alt="logo" onClick={() => router.push(PageRoutes.Home)} />
              </DialogHeader>
            ),
            default: () => <HomeMobileMenu onClose={closeDialog} />,
          }}
        </HocElDialog>
      </div>
    )
  },
})
